export default {"src":"/_next/static/media/0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};